// Version : 0.0.1
// Author : VISHAL,ARANVINDHAN,VISHNU
// LastEdit : SHIYAM
// MODFIED DATE : 01-08-2025

import EconomicActivityActionTypes from './economicActivity.types';

/** ***************** GET ECONOMIC ACTIVITY LIST START *********************** */
export const getEconomicActivityListStart = (getData: any) => ({
	type: EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_START,
	payload: getData,
});

export const getEconomicActivityListSuccess = (successData: any) => ({
	type: EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_SUCCESS,
	payload: successData,
});

export const getEconomicActivityListFailure = (failureData: any) => ({
	type: EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_FAILURE,
	payload: failureData,
});

export const getEconomicActivityListResponseResetStart = () => ({
	type: EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_RESPONSE_RESET,
});

export const getEconomicActivityListResponseChanged = () => ({
	type: EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_RESPONSE_CHANGED,
});

/** ***************** GET ECONOMIC ACTIVITY LIST END *********************** */

/** ***************** DELETE ECONOMIC ACTIVITY DETAILS START *********************** */
export const deleteEconomicActivityDetailsStart = (deleteData: any) => ({
	type: EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_START,
	payload: deleteData,
});

export const deleteEconomicActivityDetailsSuccess = (successData: any) => ({
	type: EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteEconomicActivityDetailsFailure = (failureData: any) => ({
	type: EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteEconomicActivityDetailsResponseResetStart = () => ({
	type: EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
});

export const deleteEconomicActivityDetailsResponseChanged = () => ({
	type: EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

/** ***************** ADD ECONOMIC ACTIVITY  DETAILS START *********************** */
export const addEconomicActivityDetailsStart = (addData: any) => ({
	type: EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_START,
	payload: addData,
});

export const addEconomicActivityDetailsSuccess = (successData: any) => ({
	type: EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_SUCCESS,
	payload: successData,
});

export const addEconomicActivityDetailsFailure = (failureData: any) => ({
	type: EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_FAILURE,
	payload: failureData,
});

export const addEconomicActivityDetailsResponseResetStart = () => ({
	type: EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
});

export const addEconomicActivityDetailsResponseChanged = () => ({
	type: EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD ECONOMIC ACTIVITY  DETAILS END *********************** */

/** ***************** UPDATE ECONOMIC ACTIVITY  DETAILS START *********************** */
export const updateEconomicActivityDetailsStart = (updateData: any) => ({
	type: EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_START,
	payload: updateData,
});

export const updateEconomicActivityDetailsSuccess = (successData: any) => ({
	type: EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_SUCCESS,
	payload: successData,
});

export const updateEconomicActivityDetailsFailure = (failureData: any) => ({
	type: EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_FAILURE,
	payload: failureData,
});

export const updateEconomicActivityDetailsResponseResetStart = () => ({
	type: EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
});

export const updateEconomicActivityDetailsResponseChanged = () => ({
	type: EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE ECONOMIC ACTIVITY  DETAILS END *********************** */

/** ***************** FETCH ECONOMIC ACTIVITY  DETAILS START *********************** */
export const fetchEconomicActivityDetailsStart = (fetchData: any) => ({
	type: EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_START,
	payload: fetchData,
});

export const fetchEconomicActivityDetailsSuccess = (successData: any) => ({
	type: EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchEconomicActivityDetailsFailure = (failureData: any) => ({
	type: EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchEconomicActivityDetailsResponseResetStart = () => ({
	type: EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET,
});

export const fetchEconomicActivityDetailsResponseChanged = () => ({
	type: EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH ECONOMIC ACTIVITY  DETAILS END *********************** */
